import { useQuery } from '@tanstack/react-query'

import { useDebouncedValue } from '@/hooks/use-debounced-value'

import { authApi } from '../api/auth.api'

/** Below this, the API refuses the search rather than let a single letter scan the whole tenant. */
export const MIN_DIRECTORY_QUERY_LENGTH = 2

/**
 * Debounced Entra directory search. `enabled` stays false below the minimum length, so a query never fires
 * for the single keystroke before someone has typed anything worth searching.
 */
export function useDirectorySearch(query: string) {
  const debounced = useDebouncedValue(query.trim(), 300)

  return useQuery({
    queryKey: ['directory-search', debounced],
    queryFn: ({ signal }) => authApi.searchDirectory(debounced, signal),
    enabled: debounced.length >= MIN_DIRECTORY_QUERY_LENGTH,
    staleTime: 30_000,
    // A stale or failed search is not worth retrying automatically — Graph being down should surface as
    // "unavailable" quickly, not after silent retries the caller cannot see.
    retry: false,
  })
}
